import React from "react";
import styles from "./description-wrapper.module.css";
import { v4 } from "uuid";
import { useSelector } from "react-redux";
import { selectJourneyEntities } from "../../store/selectors/journeySelectors";
import { JOURNEY_EVENT_TYPE_ENG, LOCALES, OCCUR_TYPE_ENG, SCHEDULE_CONTENT_ENG } from "../../constants";
import { getLocalizedDiffText } from "../../functions/stringFunctions";
// import { getJourneyEventByName } from "../../functions/getJourneyFunctions";

const eventNameMatcher = {
    "약탈자 토벌 의뢰": "레이더스 인카운터 승리",
    "슬라임 토벌 의뢰": "슬라포칼립스 승리",
    "남작 토벌 의뢰": "스틸 컴 인 승리",
    "탈영병 토벌 의뢰": "런 어 웨이 솔저스 승리",
    "인형 토벌 의뢰": "노 포션, 노 패션! 승리",
};

export default function DescriptionWrapper({ lang, desc, setSelected }) {
    const journeyEntities = useSelector((state) => selectJourneyEntities(state));

    return (
        <div className={styles["description-wrapper"]} key={v4()}>
            <div className={styles["description"]}>
                <div
                    className={`${styles["badge"]} ${styles["occur-type"]} ${
                        desc.occur_type === "확률" ? `${styles["per"]}` : desc.occur_type === "랜덤" ? `${styles["random"]}` : ""
                    }`}
                >
                    {lang === LOCALES.KO ? desc.occur_type : OCCUR_TYPE_ENG[desc.occur_type]}
                </div>
                <div
                    className={`${styles["badge"]} ${styles["type"]} ${
                        desc.type === "아르카나" ? `${styles["arcana"]}` : desc.type === "여정" ? `${styles["journey"]}` : ""
                    }`}
                >
                    {lang === LOCALES.KO ? desc.type : JOURNEY_EVENT_TYPE_ENG[desc.type]}
                </div>
                <div className={styles["contents"]}>
                    {desc.contents.map((content) => {
                        const diff = /(?<diff>\([가-힣,]*\)) /g.exec(content);
                        let localizedDiff;
                        if (diff) {
                            localizedDiff = getLocalizedDiffText(diff[0], lang);
                        }

                        let contentName = content.replace(/\([가-힣,]*\) /, "");
                        if (contentName.endsWith("토벌 의뢰")) {
                            contentName = eventNameMatcher[contentName];
                        }

                        const journey = journeyEntities[contentName];
                        let name;
                        if (journey && journey.name) name = journey.name[lang];
                        if (!name) name = lang === LOCALES.KO ? content : SCHEDULE_CONTENT_ENG[content];

                        return (
                            <button
                                type="button"
                                className={`${styles["badge"]} ${styles["content-name-button"]}`}
                                key={v4()}
                                onClick={() => {
                                    if (!journey && content !== "날씨" && content !== "아르카나 이벤트") return;
                                    else if (content === "날씨" || content === "아르카나 이벤트")
                                        setSelected({ content: content, desc: desc });
                                    else setSelected({ content: journey, desc: desc });
                                }}
                            >
                                {(journey || content === "날씨" || content === "아르카나 이벤트") && <i className="fi fi-rs-search" />}
                                {localizedDiff ? `${localizedDiff} ` : ""}
                                {name}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
